import * as React from 'react';
import { useGlobal } from '@/utils/useGlobal';
import { getBannerConf } from './util';
import styled from './index.module.scss';
import EFPicture from 'elem/compCommon/EFPicture';
import EditorLink from 'lowcode/components/EditorLink';

import type { BannerItemType } from './util';

const ProductInlineBanner = ({ style }: any) => {
    const { useRouter, getSystemTime } = useGlobal();
    const time = getSystemTime();

    const router = useRouter();
    const { locale } = router;
    const { debug } = router.query;

    const [banner, setBanner] = React.useState<BannerItemType | null>(null);

    React.useEffect(() => {
        const res = getBannerConf(locale, time, debug);
        console.log(res);
        res && setBanner(res);
    }, []);

    if (banner && banner?.visible) {
        return (
            <div className={styled.ProductInlineBanner} style={style}>
                <EFPicture
                    src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718698984250/pd_banner_pc.jpg'}
                    srcPad={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718700112215/pd_banner_pad.jpg'}
                    srcMobile={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718700935271/pd_banner_m.jpg'}
                    alt={banner?.title}
                />
                <div className={`pib_content ${banner?.status}`}>
                    <div>
                        <div className="pib_title">{banner?.title}</div>
                        <div className="pib_subtitle">{banner?.subtitle}</div>
                    </div>
                    <EditorLink className="pib_button_buy" href={banner?.link} target="_blank">
                        Buy Now
                    </EditorLink>
                </div>
            </div>
        );
    }

    return <></>;
};

export default ProductInlineBanner;
